const LazyLoad = (() => {
    const DOM = {};
    let options;

    const cacheDOM = () => {
        DOM.LazyLoadImages = [].slice.call(document.querySelectorAll('.lazy-background'));
    };

    const lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
        if (entry.isIntersecting) {
            const dataBackgroundImage = entry.target.dataset.bg;
            entry.target.style.backgroundImage = 'url('+ dataBackgroundImage +')';
            lazyBackgroundObserver.unobserve(entry.target);
        }
        });
    });

    const lazyImages = () => {
        DOM.LazyLoadImages.forEach(lazyLoadImage => {
            lazyBackgroundObserver.observe(lazyLoadImage);
          });
    };

    const loadImage = () => "IntersectionObserver" in window;

    const init = () => {
        cacheDOM();
        if ( loadImage() ) {
            lazyImages();
        }
    };

    return { init };
})();

export default LazyLoad;
